import Vue from "vue";
import VueRouter from "vue-router";

const appMode = localStorage.getItem('appMode') || 'hms';

import auth from "./auth";
import ehms from "./ehms";
import inventory from "./inventory";

let appRoutes = '';

if (appMode === 'hms') {
    appRoutes = ehms;
} else if (appMode === 'inventory') {
    appRoutes = inventory;
}

Vue.use(VueRouter);

const router = new VueRouter({
    routes: [
        ...appRoutes,

        ...auth,
        {
            path: "/error",
            component: () => import("../views/Error"),
        },
        {
            path: "*",
            component: () => import("../views/Error"),
        }
    ],
    mode: "history",
    linkActiveClass: "active"
});

export default router;
